import  {__extends} from './eXcell';
import eXcell_ed from './eXcell_ed';

var eXcell_edtxt = (function (_super) {
    __extends(eXcell_edtxt, _super);
    function eXcell_edtxt(a) {
        _super.call(this);
        if (a) {
            this.cell = a;
            this.grid = this.cell.parentNode.grid;
        }
    }
    eXcell_edtxt.prototype.getValue = function () {
        if (this.cell.firstChild &&
            (this.cell.atag && this.cell.firstChild.tagName == this.cell.atag)) {
            return this.cell.firstChild.value;
        }
        if (this.cell._clearCell) {
            return "";
        }
        return dhx4.isIE ? this.cell.innerText : this.cell.textContent;
    };
    eXcell_edtxt.prototype.setValue = function (c) {
        if (!c || c.toString()._dhx_trim() == "") {
            c = " ";
            this.cell._clearCell = true;
        }
        else {
            this.cell._clearCell = false;
        }
        this.setCTxtValue(c);
    };
    return eXcell_edtxt;
})(eXcell_ed);
window.eXcell_edtxt = eXcell_edtxt;



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/gridXCell/eXcell_edtxt.js